export const validPassword = new RegExp(/^(?=.*[a-zA-Z0-9])(?=.*[^\da-zA-Z]).{8,}$/)
